await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false);

class CartAdd extends McElement {
  connectedCallback() {
    this.addEventListener("click", this.add.bind(this));
  }

  add = (event) => {
    // Check if button is disabled
    if (this.hasAttribute('disabled') || this.getAttribute('aria-disabled') === 'true' || this.dataset.disabled === 'true') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const form = this.closest("form");
    if(!this.dataset.variant || !form){
      console.error("CartAdd: No variant ID or form found");
    }

    if(this.dataset.variant != undefined) {
      this.addItems();
    } else {
      this.addForm(form);
    }
  }

  addForm = (form) => {
    McShopify.addToCart({
        form: form,
    });
  }

  addItems = () => {
    const quantity = parseInt(this.dataset.quantity) || 1;
    if(isNaN(quantity) || quantity < 1) {
      console.error("CartAdd: Invalid quantity");
      return;
    }

    McShopify.addToCart({
      items: [{
        id: this.dataset.variant,
        quantity: quantity
      }]
    });
  }
}

if (!customElements.get('cart-add')) {
    customElements.define('cart-add', CartAdd);
}
window.CartAdd = CartAdd;
